
export default {
  data() {
    return {
      options: [
        {
          name: "icon",
          label: this.$t("label.icon"),
          type: "image",
          size: "32x32",
        },
        {
          name: "number",
          label: this.$t("label.number"),
          type: "number",
        },
        {
          name: "prefix",
          label: this.$t("label.prefix"),
          type: "text",
        },
        {
          name: "title",
          label: this.$t("label.title"),
          type: "text",
        },
      ],
    };
  },

  mounted() {
    this.$nextTick(() => {
      this.isInViewport("numbers");
    });
  },

  methods: {
    isInViewport(id) {
      if (typeof document !== "undefined") {
        const el = document.getElementById(id);

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const intersecting = entry.isIntersecting;

              if (intersecting) {
                setTimeout(() => {
                  this.animateNum();
                }, 1000);
              }
            });
          },
          {
            threshold: 0.5,
          }
        );

        if (el) {
          observer.observe(el);
        }
      }
    },

    animateNum() {
      const counters = document.querySelectorAll(".num");
      const speed = 2000;

      counters.forEach((counter) => {
        const value = +counter.getAttribute("start");
        const data = +counter.innerText;

        const time = value / speed;
        if (data < value) {
          counter.innerText = Math.ceil(data + time);

          setTimeout(() => {
            this.animateNum();
          }, 100);
        } else {
          counter.innerText = value;
        }
      });
    },
  },
};
